<template>
<svg xmlns="http://www.w3.org/2000/svg" :fill="useCurrentColor ? 'currentColor' : '#000'" viewBox="0 0 48 48" :class="[`${prefix}-icon`, `${prefix}-icon-Simplify`]" width="1em" height="1em" v-bind="$attrs"><defs><clipPath id="svg_30835c3227__a"><rect width="48" height="48" rx="0"/></clipPath></defs><g clip-path="url(#svg_30835c3227__a)"><path d="M17.4033,8L5,40L8.88432,40L12.23897,31.0364L26.7169,31.0364L30.0715,40L34,40L21.5967,8L17.4033,8ZM13.38661,27.944L19.433799999999998,11.94398L19.6104,11.94398L25.5693,27.944L13.38661,27.944Z"/><path d="M30 11.5L41 11.5C41.8284 11.5 42.5 10.82843 42.5 10 42.5 9.171573 41.8284 8.5 41 8.5L30 8.5C29.171573 8.5 28.5 9.171573 28.5 10 28.5 10.82843 29.171573 11.5 30 11.5zM32 20.5L41 20.5C41.8284 20.5 42.5 19.82843 42.5 19 42.5 18.171573 41.8284 17.5 41 17.5L32 17.5C31.171573 17.5 30.5 18.171573 30.5 19 30.5 19.82843 31.171573 20.5 32 20.5zM34 29.5L41 29.5C41.82843 29.5 42.5 28.82843 42.5 28 42.5 27.171573 41.82843 26.5 41 26.5L34 26.5C33.171573 26.5 32.5 27.171573 32.5 28 32.5 28.82843 33.171573 29.5 34 29.5zM37 38.5L41 38.5C41.82843 38.5 42.5 37.82843 42.5 37 42.5 36.171573 41.82843 35.5 41 35.5L37 35.5C36.171573 35.5 35.5 36.171573 35.5 37 35.5 37.82843 36.171573 38.5 37 38.5z" fill-rule="evenodd"/></g></svg>
</template>
<script>

export default {
  name: 'IconSimplify',
  props: {
    prefix: {
        type: String,
        default: 'cmstopgpt',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
